import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import moment from 'moment';
import { Table, Select, DatePicker, Spin, Input, Empty, Button} from 'antd';
import { ArrowRightOutlined,ArrowLeftOutlined } from '@ant-design/icons';
import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;
const { TextArea } = Input;

const Reports = () => {

  const [loading, setLoading] = useState(true)
  const [reportList, setReportList] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [selectedReport, setSelectedReport] = useState([])
  const [parameters, setParameters] = useState([])
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [venueList, setVenuelist] = useState([])
  const [gameTypes, setGameTypes] = useState([])
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')
  const [selectedVenue, setSelectedVenue] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const [selectedCityId, setSelectedCityId] = useState('')
  const [selectedGameType, setSelectedGameType] = useState('')
  const [endDate, setEndDate] = useState('')

  useEffect(() => {
    getReports()
    getVenues()
  }, []);

  useEffect(() => {
    setSelectedDate('')
    setSelectedMonth('')
    setSelectedVenue('')
    setSelectedCity('')
    setSelectedCityId('')
    setSelectedGameType('')
    setGameTypes([])
  }, [selectedReport])

  useEffect(() => {
    if(selectedCityId || selectedVenue){
      getGameTypes()
    }
  }, [selectedCityId,selectedVenue])

  const getReports = async () => {
    await getData('/business/get_reports_list/')
    .then(response =>{
      setReportList(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
      setVenuelist(response.result)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getGameTypes = async () => {
    var venueId = 'All'
    if(selectedVenue){
      venueId = selectedVenue
    }
    await getData(`/business/get_programs_for_venue/?venue_id=${venueId}&city_id=${selectedCityId}`)
    .then(response =>{
      setGameTypes(response.programs)
      setSelectedGameType('')
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }
  
  const getResults = (report) => {
    if(report.parameters.length == 0){
      const url = `https://api.sporthood.in/report/${report.report_no}`
      window.open(url, '_blank'); 
    }
    else{
      setSelectedReport(report)
      reorderParameters(report.parameters)
      setShowForm(true)
    }
  }

  const reorderParameters = (params) => {
    const desiredOrder = ["city", "venue_id", "game_type_id", "start_date", "end_date","date","month"];
    var orderedParams = desiredOrder.filter(param => params.includes(param));
    setParameters(orderedParams)
  }

  const closeForm = () => {
    setSelectedReport([])
    setShowForm(false)
  }

  const onChangeDate = (date, dateString) => {
    setSelectedDate(dateString)
  };

  const onChangeMonth = (date, dateString) => {
    setSelectedMonth(dateString)
  }

  const onChangeEndDate = (date, dateString) => {
    setEndDate(dateString)
  }

  const openReport = (report) =>{
    var report_no = report.report_no
    var parameters = report.parameters

    let url = `https://api.sporthood.in/report/${report_no}/?`;

    parameters.forEach((param, index) => {
      const value = getValuesForArguments(param); 

      if (value !== null) {
        url += `${param}=${value}`;
        
        if (index < parameters.length - 1) {
          url += '&';
        }
      }
    });
    window.open(url, '_blank'); 
    closeForm()
  }

  const getValuesForArguments = (parameter) => {
    if(parameter == 'date' || parameter == 'start_date'){
      return selectedDate
    }
    else if(parameter == 'end_date'){
      return endDate
    }
    else if(parameter == 'month'){
      return selectedMonth
    }
    else if(parameter == 'venue_id'){
      return selectedVenue || 'All'
    }
    else if(parameter == 'city'){
      return selectedCity
    }
    else if(parameter == 'game_type_id'){
      return selectedGameType
    }
    else{
      return null
    }
  }

  const assignCity = (cityId, cityName) =>{
    setSelectedCity(cityName)
    setSelectedCityId(cityId)
    setSelectedVenue('')
    setSelectedGameType('')
    setVenuelist( 
        venues.filter((item)=>{return item.city === cityId})
      ) 
  }

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.Header>          
          <span>Reports</span>
        </Styled.Header>
       
      {
        showForm ?
        <Styled.Body>
          {selectedReport &&
            <Styled.Form className ='col-md-8'>
              <Styled.FormHeading>
                <ArrowLeftOutlined onClick={()=>closeForm()} style={{cursor:'pointer'}}/>
                <span>Enter Details for Report</span>
                <div></div>
              </Styled.FormHeading>
              
              <Styled.FormOption>
                <div className='col-md-1'> </div> 
                <Styled.Option className='col-md-4'>Report Name</Styled.Option>
                <div className='col-md-7'>{selectedReport.report_title}</div>
              </Styled.FormOption>
              
              {
                parameters.map(x=>(
                    x === 'date' ? 
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select Date</Styled.Option>
                        <DatePicker className='col-md-7' onChange={onChangeDate} />
                      </Styled.FormOption>
                  : x === 'start_date' ?
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select Start Date</Styled.Option>
                        <DatePicker className='col-md-7' onChange={onChangeDate} />
                      </Styled.FormOption>
                  : x === 'end_date' ?
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select End Date</Styled.Option>
                        <DatePicker className='col-md-7' onChange={onChangeEndDate} />
                      </Styled.FormOption>
                  :
                    x === 'city' ? 
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select City</Styled.Option>
                        <Select
                          showSearch
                          className='col-md-7'
                          placeholder="Search to Select"
                          optionFilterProp="children"
                          onChange={(input,option)=>assignCity(option.value, option.key)}
                          value={selectedCity}
                          filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                          <Option value='' key=''>Choose City</Option>
                          {
                            cities.map(item=>(
                              <Option value={item.id} key={item.name}>{item.name}</Option>
                            ))
                          }
                         
                        </Select>
                      </Styled.FormOption>
                  :
                    x === 'venue_id' ? 
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select Venue</Styled.Option>
                        <Select
                          showSearch
                          className='col-md-7'
                          placeholder="Search to Select"
                          optionFilterProp="children"
                          onChange={(input,option)=>setSelectedVenue(option.value)}
                          value={selectedVenue}
                          filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                          <Option value='' key=''>{selectedCity ? 'All' : 'Choose Venue'}</Option>
                          {
                            venueList.map(item=>(
                              <Option value={item.id} key={item.id}>{item.name}</Option>
                            ))
                          }
                         
                        </Select>
                      </Styled.FormOption>
                  :
                    x === 'game_type_id' ? 
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Select Program</Styled.Option>
                        <Select
                          className='col-md-7'
                          placeholder="select program" 
                          onChange={(input,option)=>setSelectedGameType(option.value)}
                          value = {selectedGameType}
                        >                      
                          <Option value=''>Choose Program</Option>
                          {
                            gameTypes.map(item=>(
                              <Option value={item.pk} key={item.pk}>{item.game + ' ' + item.name}</Option>
                              ))
                          }
                          
                        </Select>
                      </Styled.FormOption>
                  :
                    x === 'month' ? 
                      <Styled.FormOption>
                        <div className='col-md-1'> </div> 
                        <Styled.Option className='col-md-4'>Enter Month</Styled.Option>
                        <DatePicker className='col-md-7' picker="month" onChange={onChangeMonth} />
                      </Styled.FormOption>
                  :
                    null
                  ))
              }
            
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}>
              <Button style={{backgroundColor:'#047294',color:'white',borderColor:'#047294'}} onClick={()=>openReport(selectedReport)}>Submit</Button>
            </div>

        
        </Styled.Form>
      }
        </Styled.Body>

        :
        <>
          {(reportList && reportList.length) > 0 ?
            <Styled.MainDiv>
               { reportList.map((x,index)=>(
                  <Styled.CategoryDiv>
                    <Styled.CategoryHeading>{x.category}</Styled.CategoryHeading>
                    <Styled.ReportDiv>
                    <ul>
                      {
                        x.reports.map(report => (
                          <Styled.ReportName onClick={()=>getResults(report)}>
                            {report.report_title}
                            <ArrowRightOutlined style={{ marginLeft: '20px'}}/>
                          </Styled.ReportName>
                          ))
                      }
                      </ul>
                    </Styled.ReportDiv>
                  </Styled.CategoryDiv>
                ))
              }
            </Styled.MainDiv>
            :
            <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
          }
        </>
      }

      </Styled.MainContainer>
    </Spin>
  );
}

export default Reports;